// @flow
import React, { PureComponent } from 'react';
import type { EventType } from 'types/Event';
import type { PratiqueAgenda } from 'types/Club';
import { Map, TileLayer, Marker, FeatureGroup } from 'react-leaflet';
import { withHelmet } from 'infrastructure/seo/Helmet';
import 'components/fragments/map/OpenStreetMap.css';
import L from 'leaflet';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

type Props = {
  pratiques?: PratiqueAgenda[],
  eventDetail?: EventType,
  autour?: boolean,
  geolocation?: boolean,
  style?: string,
  width: string,
  height: string,
  long: number,
  lat: number,
  zoom: number,
  openPopup: number,
  onClickMarker?: Function
};

type State = {
  loaded: boolean,
  geolocation: boolean,
  loadedZoom: number,
};
class OpenStreetMap extends PureComponent<Props, State> {
  mapRef: ?Map;
  markers: Marker[];
  features: ?FeatureGroup;
  state: State = {
    geolocation: false,
    loaded: true,
    loadedZoom: 13,
  };
  constructor() {
    super();
    this.onClickMarkerMap = this.onClickMarkerMap.bind(this);
    this.markers = [];
  }

  static defaultProps = {
    width: '425',
    height: '350',
    openPopup: -1,
    style: 'carte--normale',
    geolocation: true,
  };

  componentDidUpdate() {
    if (this.mapRef) {
      if (this.features && !this.state.loaded) {
        const bounds =  this.features && this.features.leafletElement.getBounds();
        if (bounds && this.mapRef) {
          this.mapRef.leafletElement.fitBounds(bounds);
          let zoom = this.mapRef && this.mapRef.leafletElement.getZoom();
          if (zoom && this.mapRef) {
            this.mapRef && this.mapRef.leafletElement.setView(bounds.getCenter(), (zoom - 1) > 14 ? 14 : (zoom - 1));
            this.setState({
              loadedZoom: (zoom - 1) > 14 ? 14 : (zoom - 1)
            });
          }
        }
        this.setState({
          loaded: true,
        });
      }
      this.mapRef.leafletElement.invalidateSize();
      if (this.props.openPopup >= 0) {
        this.markers[this.props.openPopup].leafletElement.openPopup();
      }
    }
  }

  onClickMarkerMap = (agenda) => {
    if (this.props.onClickMarker) {
      this.props.onClickMarker(agenda);
    }
  };
  onFeatureGroupAdd = (e) => {
    this.setState({loaded: false});
  };
  renderMarker = () => {
    const {
      eventDetail,
      lat,
      long,
      pratiques
    } = this.props;

    if (pratiques && pratiques.length > 0) {
      return pratiques.map((agenda, index) => {
        if (agenda.Adresse && agenda.Adresse.position) {
          const position = [agenda.Adresse.position.lat, agenda.Adresse.position.lng];
          return (
            <Marker position={position} key={index} ref={ref => this.markers[index] = ref} onclick={() => this.onClickMarkerMap(agenda)}></Marker>
          );
        } else {
          return null;
        }
        });
      }

    if (eventDetail) {
      const position = [eventDetail.lat, eventDetail.long];
      // @XXX Add an event detail popup ?
      return (
        <Marker position={position} />
      );
    }

    const position = [lat, long];
    return <Marker position={position} />;
  };

  render() {
    const { height, lat, long, zoom, pratiques } = this.props;
    const {
      loadedZoom
    } = this.state;
    const position = [parseFloat(lat) || 0, parseFloat(long) || 0];
    return (
        <Map
          center={position}
          zoom={zoom ? zoom : loadedZoom}
          maxZoom={20}
          ref={ref => this.mapRef = ref}
          style={{height: `${height}px`}}>
          <TileLayer
            attribution="donn&eacute;es &copy; <a href='//osm.org/copyright'>OpenStreetMap</a>/ODbL - rendu <a href='//openstreetmap.fr'>OSM France</a>"
            url="https://cache-osm.ffr.fr/tile/{z}/{x}/{y}.png" />
          {pratiques &&
          <FeatureGroup color="purple" ref={ref => this.features = ref} onAdd={this.onFeatureGroupAdd}>
            {this.renderMarker()}
          </FeatureGroup>}
          {!pratiques && 
            this.renderMarker()
          }
        </Map>
    );
  }
}

export default withHelmet(OpenStreetMap)((Helmet, pageProps) => (
  <Helmet>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/leaflet.css"/>
    <link rel="stylesheet" href="https://unpkg.com/react-leaflet-markercluster/dist/styles.min.css" />
  </Helmet>
));
